module.exports = __webpack_public_path__ + "static/block5-30b25f494ffbdc7fd370fe22588c5ebe.jpg";